<template>
    <div>
        <Toolbar>
            <!-- RIGHT -->
            <template v-slot:right>
                <button
                    class="btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5"
                    data-toggle="modal"
                    data-target="#createOfferModal"
                >
                    <i class="fas fa-plus"/>
                    {{ __('actions.create_thing', {thing: __('general.offer')}) }}
                </button>

                <HelpButton/>
            </template>
        </Toolbar>

        <Card>
            <template v-slot:icon>
                <i class="fas fa-clipboard-list"/>
            </template>
            <template v-slot:title>
                {{ __('offers.manage') }}
            </template>
            <template v-slot:description>
                {{ __('offers.manage_description') }}
            </template>

            <div v-if="offers.isNotEmpty()">
                <SelectedOffer v-for="(offer, index) in offers"
                               :key="index"
                               class="mb-2"
                               :offer="offer"
                               :stores="stores"
                               @deleted="removeOffer"
                />
            </div>
            <div v-else class="text-muted">
                {{ __('general.things.none_present_yet', {things: __('general.offers')}) }}
            </div>
        </Card>

        <CreateSelectedOfferModal :stores="stores"/>
    </div>
</template>

<script>
import SelectedOffer from '@components/SelectedOffers/SelectedOffer'
import CreateSelectedOfferModal from '@components/SelectedOffers/CreateSelectedOfferModal'
import HelpButton from '@components/HelpButton.vue'
import Toolbar from '@components/Toolbar.vue'
import Card from "@components/Cards/Card.vue";

export default {
    components: {
        Card,
        HelpButton,
        Toolbar,
        SelectedOffer,
        CreateSelectedOfferModal,
    },

    props: {
        offers: Array,
        stores: Array,
    },

    methods: {
        removeOffer(offerId) {
            this.$inertia.delete(this.$route('offers.delete', offerId));
        },
    },
}
</script>
